import ko from '@tko/build.knockout';
import BaseDialog from '../base-dialog';
import template from 'raw-loader!./common-dialog.html';

var instance = null;

function CommonDialog() {
    if (instance !== null) {
        throw new Error('Cannot instantiate more than one CommonDialog. Call CommonDialog.getInstance().');
    }
}

function CommonDialogVM(prompt, okTxt, cancelTxt, isConfirmDialog) {
    this.prompt = ko.observable(prompt);
    this.okTxt = ko.observable(okTxt);
    this.cancelTxt = ko.observable(cancelTxt);
    this.isConfirmDialog = ko.observable(isConfirmDialog);
    if (isConfirmDialog) {
        this.okButtonStyle = ko.observable('btn-default');
        this.cancelButtonStyle = ko.observable('btn-primary');
    }
    else {
        this.okButtonStyle = ko.observable('btn-primary');
        this.cancelButtonStyle = ko.observable('btn-default');
    }
}

function showDialog(prompt, context, isConfirmDialog, okTxt = 'Ok', cancelTxt = 'Cancel') {
    var vm = new CommonDialogVM(prompt, okTxt, cancelTxt, isConfirmDialog);

    return BaseDialog.showModal({
        viewModel: vm,
        template: template,
        context: context
    });
}

CommonDialogVM.prototype = {
    cancel: function() {
        this.modal.close(false);
    },
    ok: function() {
        this.modal.close(true);
    }
};

CommonDialog.prototype = {
    confirm: function(prompt, okTxt, cancelTxt) {
        return showDialog(prompt, this /*context*/, true /*isConfirmDialog*/, okTxt, cancelTxt);
    },
    alert: function(prompt) {
        return showDialog(prompt, this /*context*/);
    }
};

CommonDialog.getInstance = function() {
    if (instance === null) {
        instance = new CommonDialog();
    }
    return instance;
};

export default CommonDialog.getInstance();
